import React from "react";
import "./about.css";
import Image from "../../assets/avatar-1.png";
import AboutBox from "./AboutBox";

const About = () => {
  return (
    <section className="about container section" id="about">
      <h2 className="section__title">About Me!</h2>

      <div className="about__container grid">
        <img src={Image} alt="" className="about__img" />
        <div className="about__data grid">
          <div className="about__info">
            <p className="about__description">
              Over 10 years experiences .. Lorem ipsum dolor sit amet, sed te sumo cibo, mea in
              volumus blandit iudicabit, ne alterum maiestatis eum. Percipit honestatis scribentur
              eos ne. Timeam inimicus ex nec, usu discere luptatum cu.
              {/* <a href="" className="btn"></a> */}
            </p>
          </div>
        </div>
      </div>

      <AboutBox />
    </section>
  );
};

export default About;
